// extracted by mini-css-extract-plugin
export var layout = "Layout_layout__+nPRX";
export var main = "Layout_main__FV28D";